import { FormattedMessage } from 'react-intl';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

export type InternalErrorStateProps = {
    reloadTriggerFunction?: () => void;
    innerClassName?: string;
    fullWidth?: boolean;
};

const InternalErrorState = ({ reloadTriggerFunction, innerClassName, fullWidth }: InternalErrorStateProps) => (
    <ErrorState
        headline={<FormattedMessage id="intl-msg:common.error.emptyState.headline" />}
        message={<FormattedMessage id="intl-msg:common.error.emptyState.message" />}
        buttons={[
            {
                text: <FormattedMessage id="intl-msg:common.error.emptyState.button" />,
                onClick: reloadTriggerFunction,
            },
        ]}
        innerClassName={innerClassName}
        fullWidth={fullWidth}
    />
);

export default InternalErrorState;
